import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/HTML/Layout";
import Home from "./pages/home/Home";
import UVM from "./pages/technologies/toolsandlanguages/uvm/UVM";
import Contact from './pages/contact/ContactSection'
import JobOpenings from "./pages/careers/job-openings/CareersJobOpenings";
import AboutUs from "./pages/aboutus/AboutUsSection";
import ServicesPage from "./pages/services/ServicesPage";

// ASIC Design pages
import ASICDesign from "./pages/services/asicdesign/ASICDesign";
import FrontEndRTLDesign from "./pages/services/asicdesign/front-end-rtl-design/FrontEndRTLDesign";
import IPDevelopment from "./pages/services/asicdesign/ip-development/IPDevelopment";
import LowPowerDesign from "./pages/services/asicdesign/low-power-design/LowPowerDesign";
import SoCIntegrations from "./pages/services/asicdesign/soc-integrations/SocIntegrations";

// Technologies
import TechnologiesPage from "./pages/technologies/TechnologiesPage";
import Methodologies from "./pages/technologies/methodologies/Methodologies";
import CICD from "./pages/technologies/methodologies/cicd/CICD";
import ToolsAndLanguages from "./pages/technologies/toolsandlanguages/ToolsAndLanguages";
import SystemVerilog from "./pages/technologies/toolsandlanguages/systemverilog/Systemverilog";

// ASIC Verification pages
import ASICVerification from "./pages/services/asicverification/ASICVerification";
import FormalVerification from "./pages/services/asicverification/formal-verification/FormalVerification";
import RegressionTestingCoverage from "./pages/services/asicverification/regression-testing-and-coverage/RegressionTestingCoverage";
import FunctionalVerification from "./pages/services/asicverification/functional-verification/FunctionalVerification";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>}/>
        <Route path="/services" element={ <Layout> <ServicesPage/> </Layout>}/>
        <Route path="/services/asic-design" element={ <Layout><ASICDesign/></Layout>}/>
        <Route path="/services/asic-design/front-end-RTL-design" element={ <Layout><FrontEndRTLDesign /></Layout>}/>
        <Route path="/services/asic-design/ip-development" element={ <Layout> <IPDevelopment /></Layout>}/>
        <Route path="/services/asic-design/soc-integration" element={ <Layout><SoCIntegrations /></Layout>}/>
        <Route path="/services/asic-design/low-power-design" element={ <Layout><LowPowerDesign /></Layout>}/>

        <Route path="/services/asic-verification" element={ <Layout><ASICVerification></ASICVerification></Layout>}/>
        <Route path="/services/asic-verification/uvm-based-testbenches" element={ <Layout> <UVM /></Layout>}/>
        <Route path="/services/asic-verification/functional-verification" element={ <Layout><FunctionalVerification /></Layout>}/>
        <Route path="/services/asic-verification/formal-verification" element={ <Layout><FormalVerification/></Layout>}/>
        <Route path="/services/asic-verification/regression-testing-and-coverage" element={ <Layout><RegressionTestingCoverage/></Layout>}/>

        <Route path="/technologies" element={ <Layout><TechnologiesPage/></Layout>}/>
        <Route path="/technologies/tools-and-languages" element={ <Layout><ToolsAndLanguages /></Layout>}/>
        <Route path="/technologies/tools-and-languages/systemverilog" element={ <Layout><SystemVerilog/></Layout>}/>
        <Route path="/technologies/tools-and-languages/vhdl" element={ <Layout> <UVM /></Layout>}/>
        <Route path="/technologies/tools-and-languages/uvm" element={ <Layout> <UVM /></Layout>}/>
        <Route path="/technologies/tools-and-languages/formal-verification-tools" element={ <Layout> <UVM /></Layout>}/>

        <Route path="/technologies/methodologies" element={ <Layout><Methodologies/></Layout>}/>
        <Route path="/technologies/methodologies/agile-hardware-development" element={ <Layout> <UVM /></Layout>}/>
        <Route path="/technologies/methodologies/ci-cd" element={ <Layout><CICD/></Layout>}/>

        <Route path="/technologies/platforms" element={ <Layout> <UVM /></Layout>}/>
        <Route path="/technologies/platforms/emulators" element={ <Layout> <UVM /></Layout>}/>

        <Route path="/about-us" element={ <Layout><AboutUs /></Layout>}/>
        <Route path="/careers/job-openings" element={<Layout><JobOpenings/></Layout>}/>
        <Route path="/contact" element={ <Layout><Contact/></Layout>}/>
      </Routes>
    </Router>
  );
}

export default App;